import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-426">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-427">
        <CTASection headline="Need Database Expertise?" body="Let's discuss your data architecture, migration, or optimization requirements." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-428" />
      </div>
    </section>;
}